module.exports = __webpack_public_path__ + "img/brand.e3cea6e8.jpg";